import { CyclesPage } from '@/features/cycles/pages/CyclesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/cycles')({
  component: CyclesPage,
});
